import queryString from 'query-string';
import * as authApi from '@/api/auth';
import * as wxHelper from '@/helper/wx';

const wxConfig = wxHelper.getWXConfigByDomain();

const handleWXCallback = {
    methods: {
        async $_handleWXCallback() {
            this.$log('loginByWX');
            // code 可能在 hash 中，也可能在 query 中
            let code = this.$route.query['code'];
            if (!code) {
                code = queryString.parse(window.location.search).code;
            }

            // 由于某种原因，code 在 url queryString 中不存在
            if (typeof code === 'undefined') {
                console.warn('企业微信 code 不存在');
                await this.$router.push({path: '/login'});
            } else {
                let res;
                let agentId = this.$route.query['agentId'];
                const productCode = this.$route.query['productCode'];
                if (!agentId) {
                    agentId = wxConfig.agentId;
                }
                try {
                    res = await authApi.wxLogin(code, agentId, productCode);
                } catch (e) {
                    await this.$router.push({path: '/login'});
                    return;
                }

                await this.$_loginSuccess(res);
            }
        },
    }
};

export default handleWXCallback;
